/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Portuguese (Brazil)
export default {
    'fabric.atlassianSwitcher.switchTo': 'Alternar para',
    'fabric.atlassianSwitcher.switchToTooltip': 'Alternar para...',
    'fabric.atlassianSwitcher.recent': 'Recentes',
    'fabric.atlassianSwitcher.more': 'Mais',
    'fabric.atlassianSwitcher.try': 'Testar',
    'fabric.atlassianSwitcher.manageList': 'Gerenciar lista',
    'fabric.atlassianSwitcher.jiraProject': 'Projeto do Jira',
    'fabric.atlassianSwitcher.confluenceSpace': 'Espaço do Confluence',
    'fabric.atlassianSwitcher.people': 'Pessoas',
    'fabric.atlassianSwitcher.administration': 'Administração',
    'fabric.atlassianSwitcher.discoverMore': 'Descobrir mais',
    'fabric.atlassianSwitcher.errorHeading': 'Algo deu errado',
    'fabric.atlassianSwitcher.errorText': 'Nós acompanhamos esses erros, mas fique à vontade para entrar em contato conosco caso a atualização não resolva as coisas',
    'fabric.atlassianSwitcher.errorImageAltText': 'Um robô quebrado e várias pessoas ocupadas no conserto dele.',
    'fabric.atlassianSwitcher.expand': 'Expandir',
};
//# sourceMappingURL=pt_BR.js.map